import { translate } from '../translate';

import type { SearchLegPlace } from '@web-platform/shared-universal-types/src/redux/state/appInitial/user/search';
import type { Nullable } from '@web-platform/shared-universal-types-utils/src/utils';

export type PlaceNameParts = {
  name: string;
  code: Nullable<string>;
};

const getPlaceCodeFormatted = (place: SearchLegPlace) => {
  const code = getPlaceCodeString(place);
  return code ? `(${code})` : null;
};

const getPlaceName = (place: SearchLegPlace): string => place.name;

export const getPlaceDisplayNameParts = (place: SearchLegPlace | undefined): PlaceNameParts => {
  if (!place) return { code: null, name: '' };
  return {
    name: getPlaceName(place),
    code: getPlaceCodeFormatted(place),
  };
};

// These functions do not handle RTL where the place's name can dynamically be either Arabic or Latin characters
// We are gradually removing their usage and replacing with using the component parts
// See right-to-left.md
const getPlaceCodeString = ({ id, type }: SearchLegPlace) => {
  const lowercasedType = (type || '').toLowerCase();

  if (lowercasedType === 'city') {
    return translate('ktxtSearchControls_as_any');
  }

  if (lowercasedType === 'everywhere') {
    return undefined;
  }

  return id;
};

export const getPlaceDisplayName = (place: SearchLegPlace): string => {
  let name = getPlaceName(place);

  const code = getPlaceCodeString(place);

  if (code) {
    name = `${name} (${code})`;
  }

  return name;
};

export const getPlacesInfo = (
  originLeg: SearchLegPlace,
  destinationLeg: SearchLegPlace,
): {
  destination: string;
  origin: string;
  placesString: string;
} => {
  const origin = getPlaceDisplayName(originLeg);
  const destination = getPlaceDisplayName(destinationLeg);
  const placesString = `${origin} - ${destination}`;
  return {
    origin,
    destination,
    placesString,
  };
};
